module.exports = __webpack_public_path__ + "media/assets/background-images/auth-bg-91ff6a326ea82994aa2572a65c9fddee.png";